/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DataModelRangeAnalysisPoint = {
    value: number;
    status: DataModelRangeAnalysisPoint.status;
    employeeDataId?: number;
    employeeName?: string | null;
    firstName?: string;
    lastName?: string;
    jobTitle?: string;
    jobCode?: string;
    jobFamilyTitle?: string;
};

export namespace DataModelRangeAnalysisPoint {

    export enum status {
        BELOW = 'below',
        WITHIN = 'within',
        ABOVE = 'above',
    }


}

